/** Environment values that are intentionally safe to read in browser code. */
function trim(value: string | undefined): string {
  return (value ?? "").trim();
}

function firstNonEmpty(...values: (string | undefined)[]): string {
  for (const value of values) {
    const normalized = trim(value);
    if (normalized) return normalized;
  }
  return "";
}

export function getSocketPublicEndpoint(): string {
  return trim(process.env.NEXT_PUBLIC_SOCKET_ENDPOINT);
}

export function getMeetPublicBaseUrl(): string {
  return trim(process.env.NEXT_PUBLIC_MEET_BASE_URL);
}

export function getPublicTimerSeconds(): number {
  const seconds = Number(process.env.NEXT_PUBLIC_TIMER_SECONDS);
  return Number.isFinite(seconds) && seconds > 0 ? seconds : 5;
}

/** Origin of the Next.js app for chat embed iframes. */
export function getNextjsEmbedOrigin(): string {
  return firstNonEmpty(process.env.NEXT_PUBLIC_NEXTJS_URL, process.env.NEXT_PUBLIC_APP_URL, process.env.FREIBURGER_URL);
}
